document.addEventListener("DOMContentLoaded", function(){

    // Selectors object
    var cache = {
        $countdown: document.querySelector('[data-product-countdown]') || false,
        $countdownContent: document.querySelector('[data-product-countdown-content]'),
        $time: document.querySelector('[data-product-countdown-time]')
    };

    if( cache.$countdown == false ) return;

    var data = {
        day: cache.$countdown.getAttribute('data-day'),
        month: cache.$countdown.getAttribute('data-month'),
        year: cache.$countdown.getAttribute('data-year'),
        hour: cache.$countdown.getAttribute('data-hour'),
        minute: cache.$countdown.getAttribute('data-minute'),
        second: cache.$countdown.getAttribute('data-second'),
        daysToShow: cache.$countdown.getAttribute('data-days-to-show'),
        showCountdown: cache.$countdown.getAttribute('data-show-countdown'),
        showDays: cache.$countdown.getAttribute('data-show-days'),
        showTime: cache.$countdown.getAttribute('data-show-time'),
        showWhenExpired: cache.$countdown.getAttribute('data-show-when-expired'),
        expiredMessage: cache.$countdown.getAttribute('data-expired-message'),
        countTo: cache.$countdown.getAttribute('data-count-to'),
    };

    var getDate = function (){

        return `${data.month} ${data.day}, ${data.year}`;
    };

    var getTime = function (){

        return `${data.hour}:${data.minute}:${data.second}`;
    };

    var getFullDate = function (){

        if( data.countTo == 'date' ){

            return new Date( getDate() ).getTime();

        }else if( data.countTo == 'time' ){

            var date = new Date();
                date.setHours(data.hour);
                date.setMinutes(data.minute);
                date.setSeconds(data.second);

            return date.getTime();

        }else{

            return new Date( getDate() + ' ' + getTime()).getTime();
        }
    };

    var checkDay = function (){

        var days    = data.daysToShow.split(","),
            today   = new Date().getDay(),
            show    = false;

        for( var i = 0; i < days.length; i++ ){

            var day = days[i];

            if( day == today ){

                cache.$countdown.classList.add('is--visible');
                return;
            }
        }
    };

    var replaceString = function (){

        var string = cache.$countdownContent.textContent;

        if( string.includes('{countdown}') ){
            
            var replacement = string.replace('{countdown}', '<span data-product-countdown-time></span>');

            cache.$countdownContent.innerHTML = replacement;
        }
    };

    var buildCountdown = function (days, hours, minutes, seconds){

        if( document.querySelector('[data-product-countdown-time]').length < 1 ){
            return;
        }

        var string = "";

        if( data.showDays ){
            string += `${days}D `;
        }

        if( data.showTime ){
            string += `${hours}H ${minutes}M ${seconds}S`;
        }

        document.querySelector('[data-product-countdown-time]').textContent = string;
    };

    var timeInterval = function (){
        
        var countDownDate = getFullDate();

        var interval = setInterval(function() {

            // Get today's date and time
            var now = new Date().getTime();
          
            // Find the distance between now and the count down date
            var distance = countDownDate - now;
          
            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
            buildCountdown(days, hours, minutes, seconds);
          
            // If the count down is finished, write some text
            if (distance < 0) {

                clearInterval(interval);
                cache.$countdown.classList.remove('is--visible');
            }
          
        }, 1000);
    };

    // Run listeners
    var listeners = function (){

        if( cache.$countdown.length < 1 ){
            return;
        }
        
        checkDay();
        replaceString();
        timeInterval();
    };


    listeners();
});